import React from 'react'
import toLink from '../../lib/phone-number-linker'

const PhoneNumberLink = ({ number, label }) => {
  if (!number) return label || null
  return <a href={toLink(number)}>{label || number}</a>
}

export default PhoneNumberLink
